import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-lg modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "input-group" }
const _hoisted_7 = { class: "input-group-append" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "error" }
const _hoisted_10 = { class: "table table-hover mt-4" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = {
  key: 2,
  class: "error"
}
const _hoisted_14 = {
  class: "text-right",
  style: {"width":"100px"}
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = ["onClick", "disabled"]
const _hoisted_19 = ["onClick"]

import { computed, toRef } from 'vue'
    import { strCompareLowerCase } from '@common/Common'

    import type {
        ProjectUsersTagsManagerViewModel,
        TagVM
    } from '@Projects/Components/ProjectUsersTagsManager'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectUsersTagsManager',
  props: {
    viewModel: {}
  },
  emits: ["create-tag", "delete-tag", "update-tag"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- derived ----------------

    const opened = computed(() => vm.value?.opened ?? false)

    const tagsView = computed<TagVM[]>(() =>
        [...(vm.value.tags ?? [])].sort((a, b) =>
            strCompareLowerCase(a.tag, b.tag)
        )
    )

    const createError = computed(() => vm.value.createError)
    const updateError = computed(() => vm.value.updateError)

    // ---------------- methods ----------------

    function handleCreateProjectUsersTag()
    {
        vm.value.createError = null
        vm.value.updateError = null

        emit('create-tag', vm.value.newTag)
    }

    function handleDeleteProjectUsersTag(tag: string)
    {
        emit('delete-tag', tag)
    }

    function handleUpdateProjectUsersTag(tagVm: TagVM)
    {
        vm.value.createError = null
        vm.value.updateError = null

        emit('update-tag', tagVm.tag, tagVm.renamedTag)
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[1] || (_cache[1] = _createElementVNode("h5", { class: "modal-title" }, "Manage people tags", -1 /* CACHED */)),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: close
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((vm.value.newTag) = $event)),
                    class: "form-control",
                    placeholder: "new tag..."
                  }, null, 512 /* NEED_PATCH */), [
                    [
                      _vModelText,
                      vm.value.newTag,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("button", {
                      class: "btn btn-outline-secondary",
                      type: "button",
                      disabled: !vm.value.newTag,
                      onClick: handleCreateProjectUsersTag
                    }, "Create tag", 8 /* PROPS */, _hoisted_8)
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, _toDisplayString(vm.value.createError), 1 /* TEXT */),
                _createElementVNode("table", _hoisted_10, [
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tagsView.value, (t) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: t.tag
                      }, [
                        _createElementVNode("td", null, [
                          (!t.editing)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "editable editable-secondary",
                                onClick: ($event: any) => (t.edit())
                              }, _toDisplayString(t.tag), 9 /* TEXT, PROPS */, _hoisted_11))
                            : _createCommentVNode("v-if", true),
                          (t.editing)
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 1,
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => ((t.renamedTag) = $event),
                                class: "form-control"
                              }, null, 8 /* PROPS */, _hoisted_12)), [
                                [
                                  _vModelText,
                                  t.renamedTag,
                                  void 0,
                                  { trim: true }
                                ]
                              ])
                            : _createCommentVNode("v-if", true),
                          (t.editing && updateError.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(updateError.value), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _createElementVNode("td", _hoisted_14, [
                          (!t.editing)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _createElementVNode("button", {
                                  type: "button",
                                  onClick: ($event: any) => (handleDeleteProjectUsersTag(t.tag)),
                                  class: "btn btn-outline-secondary btn-sm",
                                  title: "delete"
                                }, [...(_cache[2] || (_cache[2] = [
                                  _createElementVNode("i", { class: "fa fa-trash-can" }, null, -1 /* CACHED */)
                                ]))], 8 /* PROPS */, _hoisted_16)
                              ]))
                            : _createCommentVNode("v-if", true),
                          (t.editing)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _createElementVNode("button", {
                                  type: "button",
                                  onClick: ($event: any) => (handleUpdateProjectUsersTag(t)),
                                  class: "btn btn-primary btn-sm",
                                  title: "confirm",
                                  disabled: !t.canSave
                                }, [...(_cache[3] || (_cache[3] = [
                                  _createElementVNode("span", { class: "fa fa-check" }, null, -1 /* CACHED */)
                                ]))], 8 /* PROPS */, _hoisted_18),
                                _createElementVNode("button", {
                                  type: "button",
                                  onClick: ($event: any) => (t.cancelEdit()),
                                  class: "btn btn-outline-secondary btn-sm",
                                  title: "cancel"
                                }, [...(_cache[4] || (_cache[4] = [
                                  _createElementVNode("span", { class: "fa fa-times" }, null, -1 /* CACHED */)
                                ]))], 8 /* PROPS */, _hoisted_19)
                              ]))
                            : _createCommentVNode("v-if", true)
                        ])
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})